import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { GpuInstanceI } from 'src/app/core/models/nodeGpu';
import { NodeService } from 'src/app/core/services/node.service';

enum InstanceMessageI {
  Loading = "Loading instances...",
  Empty = "No instances yet.",
  Error = "Failed to load instances."
}

@Component({
  selector: 'app-manage-gpu-instances',
  templateUrl: './manage-gpu-instances.component.html',
  styleUrls: ['./manage-gpu-instances.component.scss']
})
export class ManageGpuInstancesComponent implements OnInit {

  gpuInstanceList: GpuInstanceI[] = [];
  instanceListSub$ = new BehaviorSubject<string>("");
  depName: string = this.data.depName;
  activeNodeName: string = this.data.nodeName;
  noInstanceMessage: string = InstanceMessageI.Loading;
  selectedFrame = new FormControl(this.data.frameBufferInGB?.split(",")[0]);

  constructor(
    private _dialog: MatDialogRef<ManageGpuInstancesComponent>,
    private _nodeService: NodeService,
    @Inject(MAT_DIALOG_DATA)
    public data: {gpuId: string, frameBufferInGB: string, depName: string, nodeName: string},
    private _snackBar: MatSnackBar
    ) { }

  ngOnInit(): void {
    this.getInstanceList()
  }

  ngOnDestroy(){
    this.instanceListSub$.next(null);
    this.instanceListSub$.complete();
  }

  getInstanceList(){
    this._nodeService
    .getGpuSlaveListForMaster(this.depName, this.activeNodeName, this.data.gpuId)
    .pipe(takeUntil(this.instanceListSub$))
    .subscribe({
      next: (data) => {
        if(!data){
          this.noInstanceMessage = InstanceMessageI.Empty;
        }
        this.gpuInstanceList = JSON.parse(JSON.stringify(data));
      },
      error: (err) => {
        this.noInstanceMessage = InstanceMessageI.Error;
      }
    })
  }

  createInstances(){
    this._nodeService.createInstance(this.depName, this.activeNodeName, this.data.gpuId, this.selectedFrame.value)
    .subscribe({
      next: (data) => {
        this.noInstanceMessage = InstanceMessageI.Empty;
        this._snackBar.open("Creating instance's, it may take sometime.", "Ok", {
          duration: 7000
        });
        this.onClose(true);
      },
      error: (err) => {
        this.noInstanceMessage = InstanceMessageI.Error;
      }
    })
  }

  onClose(toUpdate = false){
    this._dialog.close(toUpdate);
  }
}
